
import { Component } from '@theme/component';
import { onAnimationEnd } from '@theme/utilities';
import { ThemeEvents } from '@theme/events';
import { StandardEvents, CartLinesUpdateEvent } from '@shopify/events';

class CartIcon extends Component {
  requiredRefs = ['cartBubble', 'cartBubbleText', 'cartBubbleCount'];

  get currentCartCount() {
    return parseInt(this.refs.cartBubbleCount.textContent ?? '0', 10);
  }

  set currentCartCount(value) {
    this.refs.cartBubbleCount.textContent = value < 100 ? String(value) : '';
  }

  connectedCallback() {
    super.connectedCallback();

    document.addEventListener(
      StandardEvents.cartLinesUpdate,
      this.onCartUpdate
    );

    window.addEventListener(
      'pageshow',
      this.onPageShow
    );

    this.ensureCartBubbleIsCorrect();
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    document.removeEventListener(
      StandardEvents.cartLinesUpdate,
      this.onCartUpdate
    );

    window.removeEventListener(
      'pageshow',
      this.onPageShow
    );
  }

  onPageShow = (event) => {
    if (event.persisted) {
      this.ensureCartBubbleIsCorrect();
    }
  };

  onCartUpdate = (event) => {
    event.promise
      ?.then(({ cart, detail }) => {
        const itemCount =
          cart?.totalQuantity ??
          detail?.itemCount ??
          0;

        this.renderCartBubble(itemCount);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') {
          console.warn(
            '[cart-icon] Event promise rejected:',
            error
          );
        }
      });
  };

  renderCartBubble = async (
    itemCount,
    animate = true
  ) => {

    /*
     * Do NOT add hidden or visually-hidden
     * classes to the cart bubble.
     */

    this.currentCartCount = itemCount;

    this.classList.toggle(
      'header-actions__cart-icon--has-cart',
      itemCount > 0
    );

    sessionStorage.setItem(
      'cart-count',
      JSON.stringify({
        value: String(this.currentCartCount),
        timestamp: Date.now(),
      })
    );

    if (!animate) {
      return;
    }

    await new Promise((resolve) =>
      requestAnimationFrame(resolve)
    );

    this.refs.cartBubble.classList.add(
      'cart-bubble--animating'
    );

    try {
      await onAnimationEnd(
        this.refs.cartBubbleText
      );
    } catch (_) {}

    this.refs.cartBubble.classList.remove(
      'cart-bubble--animating'
    );
  };

  ensureCartBubbleIsCorrect = () => {

    if (!this.refs.cartBubbleCount) {
      return;
    }

    const sessionStorageCount =
      sessionStorage.getItem(
        'cart-count'
      );

    if (
      sessionStorageCount === null
    ) {
      return;
    }

    const visibleCount =
      this.refs.cartBubbleCount.textContent;

    try {

      const {
        value,
        timestamp
      } = JSON.parse(
        sessionStorageCount
      );

      if (
        value === visibleCount
      ) {
        return;
      }

      if (
        Date.now() - timestamp <
        10000
      ) {

        const count =
          parseInt(value, 10);

        if (count >= 0) {
          this.renderCartBubble(
            count,
            false
          );
        }

      }

    } catch (_) {
      // no-op
    }
  };
}

if (!customElements.get('cart-icon')) {
  customElements.define(
    'cart-icon',
    CartIcon
  );
}

